import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=68b02d0c&scoped=true&"
import script from "./SystemSettings.vue?vue&type=script&lang=js&"
export * from "./SystemSettings.vue?vue&type=script&lang=js&"
import style0 from "./SystemSettings.vue?vue&type=style&index=0&id=68b02d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b02d0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b02d0c')) {
      api.createRecord('68b02d0c', component.options)
    } else {
      api.reload('68b02d0c', component.options)
    }
    module.hot.accept("./SystemSettings.vue?vue&type=template&id=68b02d0c&scoped=true&", function () {
      api.rerender('68b02d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/SystemSettings.vue"
export default component.exports